import { createFileRoute } from '@tanstack/react-router'

import { SupabaseSettingsPage } from '#features/integrations/supabase/supabase-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/supabase',
)({
  head: () => ({
    meta: [
      {
        title: 'Supabase integration',
      },
    ],
  }),
  component: () => <SupabaseSettingsPage />,
})
